import React from "react";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { postalCodes } from "../../data/postalCodes";
import NewFormBtns from "../../../common/layout/form/NewFormBtns";
import { mergeStyles } from "office-ui-fabric-react";
import Price from "./Price";

const fieldContainer = mergeStyles({
  marginTop: 0
})

export interface EditPriceFormProps {
  handleSubmit: any;
  initValues: any;
  cancelForm: any;
  selectedPrice: any;
}

const EditPriceForm: React.FC<EditPriceFormProps> = ({
  handleSubmit,
  initValues,
  cancelForm,
  selectedPrice,
}) => {
  const { t } = useTranslation("admin");
  return (
    <Formik
      initialValues={initValues}
      enableReinitialize={true}
      onSubmit={handleSubmit}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          {selectedPrice.postalCodePrices ? (
            <div className={fieldContainer}>
              {postalCodes.map((code: string) => (
                  <Price
                    key={code}
                    name={code}
                    label={t("nav.priceForCode", { code }) as string}
                    required={false}
                  />
              ))}
            </div>
          ) : (
            <div className={fieldContainer}>
              <Price name={"price"} label={t("nav.price") as string} required={false} />
            </div>
          )}
          <NewFormBtns submitBtnText={t("nav.save") as string} cancelForm={cancelForm}  positionAbsolute={true}/>
        </Form>
      )}
    </Formik>
  );
};

export default EditPriceForm;
